export default __webpack_public_path__ + "static/media/fatca2_icon.55174333.png";